export const BLOCK_TYPE = {
  COMPANY_PROFILE: 1,
  OWNERSHIP_GROUP: 2,
  FINANCIAL_STATEMENT: 3,
  SCORE: 4,
  INDUSTRY: 5,
}

export const BLOCK_CONFIG = {
  [BLOCK_TYPE.COMPANY_PROFILE]: {
    defaultChecked: true,
    allowChange: false,
  },
  [BLOCK_TYPE.OWNERSHIP_GROUP]: {
    defaultChecked: true,
    allowChange: true,
  },
  [BLOCK_TYPE.FINANCIAL_STATEMENT]: {
    defaultChecked: true,
    allowChange: true,
  },
  [BLOCK_TYPE.SCORE]: {
    defaultChecked: true,
    allowChange: true,
  },
  [BLOCK_TYPE.INDUSTRY]: {
    defaultChecked: true,
    allowChange: false,
  },
}

export const TABLE_KEYS = {
  REPORTING_YEAR: 'reportYear',
  AUDIT_STATUS: 'auditStatus',
  METHOD: 'method',
  DATA_AVAILABILITY: 'dataAvailability',
}

export const TYPE_OF_FT_OPTIONS = [
  {
    label: 'common.order.factSheet.CONSOLIDATED',
    value: true,
    isI18n: true,
  },
  {
    label: 'common.order.factSheet.UNCONSOLIDATED',
    value: false,
    isI18n: true,
  },
]

export const AUDIT_STATUS_OPTIONS = [
  {
    label: 'common.order.factSheet.AUDITED',
    value: true,
    isI18n: true,
  },
  {
    label: 'common.order.factSheet.UNAUDITED',
    value: false,
    isI18n: true,
  },
]

export const METHOD_OPTIONS = [
  {
    label: 'common.order.factSheet.DIRECT',
    value: true,
    isI18n: true,
  },
  {
    label: 'common.order.factSheet.INDIRECT',
    value: false,
    isI18n: true,
  },
]

export const factSheetTypes = {
  POPUP_LITE: 'popup lite',
  POPUP_OTHERS: 'popup others',
  PREVIEW: 'preview',
  SETTING_DYNAMIC_REPORT: 'setting dynamic report',
}
